import { memo } from "react";

import TableSkeleton from "ds/components/Table/Skeleton";

import useIacTableStore from "./useIacTableStore";

type IacManagementTableSkeletonProps = {
  rowsPerPage: number;
};

const IacManagementTableSkeleton = memo(({ rowsPerPage }: IacManagementTableSkeletonProps) => {
  const columnIds = useIacTableStore((state) => state.columnsOrder.visible);

  return <TableSkeleton rowsPerPage={rowsPerPage} columnIds={columnIds} />;
});

IacManagementTableSkeleton.displayName = "IacManagement.Table.Skeleton";

export default IacManagementTableSkeleton;
